import { displayDollar } from "utilities/tableUtility";
import { Flex } from "common/components/flex/flex";
import { ModalPortal } from "common/components/modalPortal/modalPortal";
import { EligibilityTag } from "../../../components/eligibilityTag/eligibilityTag";
import { MetricIconBadge } from "../../../components/metricIconBadge/metricIconBadge";
import { MetricItem } from "../../../components/metricItem/metricItem";
import { UserCheckIcon } from "../../../components/icons/UserCheckIcon";
import { StarIcon } from "../../../components/icons/StarIcon";
import { TotalHiresModal } from "./totalHiresModal/totalHiresModal";
import { EstimatedCommissionModal } from "./estimatedCommissionModal/estimatedCommissionModal";
import * as styles from "./goalMetrics.module.scss";

const MetricValue = ({ value, isClickable, renderModal }) => {
  if (!isClickable || !renderModal) {
    return <MetricItem.Value>{value}</MetricItem.Value>;
  }

  return (
    <ModalPortal
      renderTrigger={(triggerProps) => (
        <button
          type="button"
          onClick={triggerProps.onClick}
          className="btn-reset"
        >
          <MetricItem.Value underline>{value}</MetricItem.Value>
        </button>
      )}
    >
      {renderModal}
    </ModalPortal>
  );
};

export const GoalMetrics = ({
  clientId,
  recruiterId,
  totalHires = 0,
  estimatedCommission = 0,
  isEligible = false,
  loading = false,
}) => {
  const metrics = [
    {
      label: "Total Hires",
      value: totalHires,
      icon: <UserCheckIcon />,
      iconColor: "var(--green-300)",
      iconBgColor: "var(--green-300-10)",
      className: styles.goalMetrics__totalHires,
      isClickable: totalHires > 0,
      renderModal: ({ open, closeModal }) => (
        <TotalHiresModal
          open={open}
          onClose={closeModal}
          clientId={clientId}
          recruiterId={recruiterId}
        />
      ),
    },
    {
      label: "Estimated Commission",
      value: displayDollar(estimatedCommission),
      icon: <StarIcon />,
      iconColor: "var(--gray-600)",
      iconBgColor: "var(--gray-600-10)",
      className: styles.goalMetrics__estimatedCommission,
      isClickable: true,
      extra: <EligibilityTag isEligible={isEligible} />,
      renderModal: ({ open, closeModal }) => (
        <EstimatedCommissionModal
          open={open}
          onClose={closeModal}
          clientId={clientId}
          isEligible={isEligible}
          recruiterId={recruiterId}
        />
      ),
    },
  ];

  if (loading) {
    return (
      <Flex gap={24}>
        {metrics.map((m) => (
          <MetricItem.Skeleton key={m.label} className={m.className} />
        ))}
      </Flex>
    );
  }

  return (
    <Flex gap={24}>
      {metrics.map((m) => (
        <MetricItem
          className={m.className}
          key={m.label}
          label={m.label}
          icon={
            <MetricIconBadge
              icon={m.icon}
              color={m.iconColor}
              bgColor={m.iconBgColor}
            />
          }
        >
          <MetricValue
            value={m.value}
            isClickable={m.isClickable}
            renderModal={m.renderModal}
          />
          {m.extra}
        </MetricItem>
      ))}
    </Flex>
  );
};
